@if (loading) {
    <span [class.opened]="isModalOpen()" class="homework-item">
    <img [src]="'sidebar/spinner-blue.svg' | asset" alt="Beispiele werden geladen..."
         class="spinner"/> Das Dokument wird erstellt...
    </span>
}
@if (!loading) {
    <div [class.opened]="isModalOpen()" class="homework-item">
        <div (click)="showLink(test)"
             (keydown.enter)="showLink(test)"
             (keydown.space)="$event.preventDefault(); showLink(test)"
             class="homework-content"
             tabindex="0"
             role="button"
        >
            <span class="homework-title">{{ title }}</span>
        </div>

        <div class="dropdown-element">
            <div class="dropdown">
                <button
                    class="btn btn-link p-0 dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-offset="20, 5"
                    type="button"
                >
                    <i class="fas fa-angle-down statistic"></i>
                </button>
                <ul class="dropdown-menu">
                    <li class="dropdown-item">
                        <button (click)="showLink(test)">
                            <i class="fas fa-link"></i>Abgabelink anzeigen
                        </button>
                    </li>
                    <li><hr class="dropdown-divider"></li>
                    <li class="dropdown-item"><a class="d-block" [href]="test.getLink()" target="_blank"><i class="fas fa-external-link-square"></i>Test öffnen</a></li>
                    <li><hr class="dropdown-divider"></li>
                    <li class="dropdown-item"
                    >
                        <button (click)="edit()">
                            <i class="far fa-edit"></i>Test bearbeiten
                        </button>
                    </li>
                    <li><hr class="dropdown-divider"></li>
                    <li class="dropdown-item">
                        <button (click)="getPdfDownload()">
                            <i class="far fa-file-pdf"></i>PDF herunterladen<li>
                        </button>
                    <li class="big-divider"></li>
                    <li class="dropdown-item"><a class="d-block" [href]="downloadLink" target="_blank"><i class="fas fa-analytics"></i>Auswertung anzeigen</a></li>
                    @if (!foreign) {
                        <li><hr class="dropdown-divider"></li>
                        <li class="dropdown-item red">
                            <button (click)="deleteTest(test)">
                                <i class="fas fa-times"></i>Aus Liste entfernen
                            </button>
                        </li>
                    }
                </ul>
            </div>
        </div>
    </div>
}
